export default "a14c3ddb6cccd639e2b1216069f7103f.png";